import { render, staticRenderFns } from "./Bin_details.vue?vue&type=template&id=0ce3baef&scoped=true&"
import script from "./Bin_details.vue?vue&type=script&lang=js&"
export * from "./Bin_details.vue?vue&type=script&lang=js&"
import style0 from "./Bin_details.vue?vue&type=style&index=0&id=0ce3baef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce3baef",
  null
  
)

export default component.exports